import { render, staticRenderFns } from "./organization-unit-tree.vue?vue&type=template&id=8055527e&scoped=true&"
import script from "./organization-unit-tree.vue?vue&type=script&lang=js&"
export * from "./organization-unit-tree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8055527e",
  null
  
)

export default component.exports